import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';
const API_URL = `${API_BASE}/financiero/fin-pagos`;

/**
 * Cambiar el estado de un pago (FinPago) por folio_recibo.
 * Solo debe usarse desde pantallas protegidas (Superadministrador).
 *
 * @param {string} folioRecibo - Folio del recibo (fin_pagos.folio_recibo)
 * @param {('APLICADO'|'CANCELADO')} nuevoEstado - Estado destino
 */
export const cambiarEstadoPagoPorFolio = async (folioRecibo, nuevoEstado) => {
  try {
    const response = await axios.post(`${API_URL}/cambiar-estado/`, {
      folio_recibo: folioRecibo,
      estado: nuevoEstado,
    });
    return response.data;
  } catch (error) {
    console.error('Error al cambiar estado del pago:', error);
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

/**
 * Registrar un pago pendiente (o reutilizar uno existente) en fin_pagos.
 * @param {Object} datosPago - { id_estudiante, id_cargo, referencia_bancaria, monto, id_campus, usuario_creacion }
 * @returns {Promise<Object>} - Respuesta del backend con el pago y si ya existía
 */
export const registrarPagoPendiente = async (datosPago) => {
  try {
    const response = await axios.post(`${API_BASE}/financiero/registrar_pago_pendiente/`, datosPago);
    return response.data;
  } catch (error) {
    console.error('Error al registrar pago pendiente:', error);
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};
